import { createAction, props } from '@ngrx/store';

import { ScannerStatus, UpdateBasketItemParams } from '../models';
import { ListTarget, ProductByBarcode, ScanTarget } from '../models';

export const clearBarcodeResults = createAction(
  '[Scanner] Clear barcode results',
);

export const barcodeRead = createAction(
  '[Scanner] Barcode read',
  props<{ barcode: string }>(),
);

export const findProduct = createAction(
  '[Scanner] Find product',
  props<{ barcode: string }>(),
);

export const productFound = createAction(
  '[Scanner] Product found',
  props<{ product: ProductByBarcode; barcode: string }>(),
);

export const productNotFound = createAction(
  '[Scanner] Product not found',
  props<{ barcode: string }>(),
);

export const noTargetSelected = createAction('[Scanner] no target selected');

export const addToList = createAction(
  '[Scanner] Add to list',
  props<{
    barcode: string;
    product: ProductByBarcode;
    target: ListTarget;
  }>(),
);

export const addToListSuccess = createAction(
  '[Scanner] Add to list success',
  props<{ barcode: string; product: ProductByBarcode; target: ListTarget }>(),
);

export const addToListFail = createAction(
  '[Scanner] Add to list fail',
  props<{
    barcode: string;
    product: ProductByBarcode;
    target: ListTarget;
    reason?: ScannerStatus;
  }>(),
);

export const addToBasket = createAction(
  '[Scanner] Add to basket',
  props<{ barcode: string; product: ProductByBarcode }>(),
);

export const shopScannedProductToBasket = createAction(
  '[Scanner] Shop scanned product to basket',
  props<{
    product: ProductByBarcode;
    quantity: number;
    updateBasketItemParams: UpdateBasketItemParams;
    mode: 'add' | 'update';
    barcode?: string;
  }>(),
);

export const addToBasketSuccess = createAction(
  '[Scanner] Add to basket success',
  props<{ barcode: string; product: ProductByBarcode }>(),
);

export const addToBasketFail = createAction(
  '[Scanner] Add to basket fail',
  props<{
    barcode: string;
    product: ProductByBarcode;
    reason?: ScannerStatus;
  }>(),
);

export const barcodeDuped = createAction(
  '[Scanner] Barcode duped',
  props<{ barcode: string; target: ScanTarget }>(),
);

export const targetChange = createAction(
  '[Scanner] target change',
  props<{ target?: ScanTarget }>(),
);

export const clearCurrentBarcodeForNext = createAction(
  '[Scanner] clear current barcode for next',
);
